import { install as installResizeObserver } from 'resize-observer';

if (!window.ResizeObserver) {
  installResizeObserver();
}
